import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectMinerTypesLoaded } from './miner.selectors';
import { getMinerTypesThunk } from './miner.thunks';

// Miner types are no longer preloaded at app startup (see App.js) — the forms that need them
// (add miner, add product, miner details) call this hook to fetch on demand, once per session
// (the loaded flag is set by the fetch-success reducer).

export const useEnsureMinerTypes = () => {
  const dispatch = useDispatch();
  const loaded = useSelector(selectMinerTypesLoaded);

  useEffect(() => {
    if (!loaded) {
      dispatch(getMinerTypesThunk());
    }
  }, [dispatch, loaded]);
};
